import React, { useEffect, useState } from "react"

import "./EntrenoEntry.css"

import { CCard, CCardBody } from "@coreui/react"
import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
} from "@mui/material"
import StarIcon from "@mui/icons-material/Star"
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight"
import "@coreui/coreui/dist/css/coreui.min.css"
import { Typography } from "@mui/material"

function EntrenoEntry({ data }) {
	const [partido_info, setPartidoInfo] = useState(null)
	const [wod_info, setWODInfo] = useState(null)
	const [natacion_info, setNatacionInfo] = useState(null)
	const [aletas_info, setAletasInfo] = useState(null)
	const [isHockey, setHockey] = useState(false)
	const [isNatacion, setNatacion] = useState(false)
	const [error, setError] = useState(false)
	const [isLoading, setLoading] = useState(true)

	//console.log(data.DATE)
	// const work_date = new Date(
	// 	data.DATE.seconds * 1000 + data.DATE.nanoseconds / 1000000
	// )
	//console.log(data)
	useEffect(() => {
		//console.log(data)
		if (data.id.includes("Hockey")) setHockey(true)
		else if (data.id.includes("Natacion")) setNatacion(true)
		else setError(true)

		try {
			if (data.WOD) {
				const wod_info_ret = Object.entries(data.WOD)
				setWODInfo(wod_info_ret)
			}
			if (data.PARTIDO) {
				const partido_info_ret = Object.entries(data.PARTIDO)
				setPartidoInfo(partido_info_ret)
			}
		} catch (ex1) {
			console.log("hockey - error", ex1)
			//alert(ex1)
		}
		try {
			if (data.NATACION) {
				const natacion_info_ret = Object.entries(data.NATACION)
				setNatacionInfo(natacion_info_ret)
			}
			if (data.ALETAS) {
				const aletas_info_ret = Object.entries(data.ALETAS)
				setAletasInfo(aletas_info_ret)
			}
		} catch (ex) {
			console.log("natacion - error", ex)
			//alert(ex)
		}
		setLoading(false)
	}, [data, isHockey, isNatacion, error])

	let parte1_components = <></>
	let parte2_components = <></>
	let wod_components = <></>
	let partido_components = <></>
	let natacion_components = <></>
	let aletas_components = <></>
	let data_parte1 = []
	let data_parte2 = []

	if (!error && !isLoading) {
		if (isHockey && wod_info && partido_info) {
			data_parte1 = wod_info
			data_parte2 = partido_info
		}

		if (isNatacion && natacion_info && aletas_info) {
			data_parte1 = natacion_info
			data_parte2 = aletas_info
		}

		parte1_components = data_parte1.map((e, i) => (
			<>
				{e[1].TITLE ? (
					<>
						{e[1].WORK ? (
							<>
								<ListItem>
									<ListItemIcon>
										<StarIcon fontSize="small" />
									</ListItemIcon>
									<ListItemText>{e[1].TITLE}</ListItemText>
								</ListItem>
								<ListItem>
									<List dense={true}>
										{e[1].WORK.map((w) => (
											<ListItem>
												<ListItemIcon>
													<SubdirectoryArrowRightIcon />
												</ListItemIcon>
												<ListItemText>{w}</ListItemText>
											</ListItem>
										))}
									</List>
								</ListItem>
							</>
						) : (
							<>
								<ListItem>
									<ListItemIcon>
										<StarIcon fontSize="small" />
									</ListItemIcon>
									<ListItemText>{e[1].TITLE}</ListItemText>
								</ListItem>
							</>
						)}
					</>
				) : (
					<ListItem>
						<ListItemIcon>
							<StarIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>{e[1].WORK}</ListItemText>
					</ListItem>
				)}
			</>
		))

		parte2_components = data_parte2.map((e, i) => (
			<>
				{e[1].TITLE ? (
					<>
						{e[1].WORK ? (
							<>
								<ListItem>
									<ListItemIcon>
										<StarIcon fontSize="small" />
									</ListItemIcon>
									<ListItemText>{e[1].TITLE}</ListItemText>
								</ListItem>
								<ListItem>
									<List dense={true}>
										{e[1].WORK.map((w) => (
											<ListItem>
												<ListItemIcon>
													<SubdirectoryArrowRightIcon />
												</ListItemIcon>
												<ListItemText>{w}</ListItemText>
											</ListItem>
										))}
									</List>
								</ListItem>
							</>
						) : (
							<>
								<ListItem>
									<ListItemIcon>
										<StarIcon fontSize="small" />
									</ListItemIcon>
									<ListItemText>{e[1].TITLE}</ListItemText>
								</ListItem>
							</>
						)}
					</>
				) : (
					<ListItem>
						<ListItemIcon>
							<StarIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText>{e[1].WORK}</ListItemText>
					</ListItem>
				)}
			</>
		))

		if (isHockey) {
			wod_components = parte1_components
			partido_components = parte2_components
		}

		if (isNatacion) {
			natacion_components = parte1_components
			aletas_components = parte2_components
		}

		// const fecha = new Date(
		// 	data.DATE.seconds * 1000 + data.DATE.nanoseconds / 1000000
		// )
	}

	return (
		<>
			{!isLoading && (
				<CCard className="text-center" responsive color={"light"}>
					{error && <div>ERROR</div>}
					{/* <Typography variant="h3">{fecha}</Typography> */}
					{isHockey && (
						<Typography variant="subtitle1" align="left" sx={{ color: "blue" }}>
							<StarIcon />
							<span> WOD</span>
						</Typography>
					)}
					{isNatacion && (
						<Typography
							variant="subtitle1"
							align="left"
							sx={{ color: "violet" }}
						>
							<StarIcon />
							<span> Natacion</span>
						</Typography>
					)}
					{isHockey && !error && <List dense={true}>{wod_components}</List>}
					{isNatacion && !error && (
						<List dense={true}>{natacion_components}</List>
					)}
					{isHockey && (
						<Typography variant="subtitle1" align="left" sx={{ color: "blue" }}>
							<StarIcon /> <span> Partido</span>
						</Typography>
					)}
					{isNatacion && (
						<Typography
							variant="subtitle1"
							align="left"
							sx={{ color: "violet" }}
						>
							<StarIcon />
							<span> Natación con aletas</span>
						</Typography>
					)}
					{isHockey && !error && <List dense={true}>{partido_components}</List>}
					{isNatacion && !error && (
						<List dense={true}>{aletas_components}</List>
					)}

					{data.NOTAS && <CCardBody>Notas: {data.NOTAS}</CCardBody>}
				</CCard>
			)}
		</>
	)
}

export default EntrenoEntry
